<div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
  @if (trackCount === 0) {
    <bmcore-beats-not-found [title]="' No beats were found!'"></bmcore-beats-not-found>
  }

  @for (group of cartGroups; track group) {
    <div class="cart-page">
      <bmcore-promo-block
        class="cart-page__promo"
        [beatmakerId]="group.beatmakerId"
        [beatmakerName]="group.beatmakerName"
        [coupon]="group.coupon"
        [hasDiscount]="group.hasDiscount"
        [isBMSTVmode]="appType === 'BMSTV'"
      >
      </bmcore-promo-block>
      <!-- Track list -->
      <div class="cart-page__tracks">
        @for (track of sortTracksByIsOk(group?.beats); track track) {
          <bmcore-track-item
            [track]="track"
            [isTrackInCart]="true"
            (setPlaylistEvent)="setPlaylist(group.beats)"
            [appType]="appType"
          >
          </bmcore-track-item>
        }
      </div>
      <bmcore-payment-block
        class="cart-page__payment"
        [group]="group"
        [paymentSource]="paymentSource"
        [colorSettingsMode]="colorSettingsMode"
        [widgetId]="widgetId"
      >
      </bmcore-payment-block>
    </div>
  }
</div>
